import { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import Calendar from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import gregorian from "react-date-object/calendars/gregorian";
import { TextInput } from "./TextInput";
import DateObject from "react-date-object";

export function DatePicker({
  value,
  onChange,
  placeholder,
  label,
  disabled,
  id,
  name,
  containerGridSize = { xs: 12, sm: 6 },
  labelGridSize = { xs: 5 },
  inputGridSize = { xs: 7 },
  error = false,
  hasClearButton = true,
  reapetedValue = "",
}) {
  return (
    <Grid container {...containerGridSize}>
      <Calendar
        calendar={persian}
        locale={persian_fa}
        mapDays={() => {
          return {
            style: {
              alignItems: "center",
            },
          };
        }}
        containerStyle={{ width: "100%" }}
        value={value}
        onChange={(date) => {
          onChange(date.convert(persian, gregorian_en));
        }}
        render={(value, openCalendar) => (
          <TextInput
            onClick={openCalendar}
            value={value}
            containerGridSize={{ width: "100%" }}
            labelGridSize={labelGridSize}
            inputGridSize={inputGridSize}
            placeholder={placeholder}
            disabled={disabled}
            label={label}
            id={id}
            name={name}
            error={error}
            reapetedValue={reapetedValue}
          />
        )}
        disabled={disabled}
      >
        {hasClearButton && (
          <Button onClick={() => onChange("")} sx={{ justifySelf: "flex-start" }}>
            پاک کردن
          </Button>
        )}
      </Calendar>
    </Grid>
  );
}
